import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, Renderer2 } from "@angular/core";
import { environment } from "src/environments/environment";

declare const grecaptcha: any;

declare global {
  interface Window {
    grecaptcha : any,
    carregaReCaptcha : () => void,
    respostaCallback : () => void,
  }
}

@Component({
  selector: 'app-recaptcha',
  templateUrl: './recaptcha.component.html',
})
export class ReCaptchaComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output() onResponder = new EventEmitter<string>();

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    window.carregaReCaptcha = this.carregaReCaptcha;
    window.respostaCallback = this.respostaCallback.bind(this);
  }

  ngAfterViewInit(): void {
    this.adicionaScript();
  }

  ngOnDestroy(): void {
    this.removeScript();
  }

  carregaReCaptcha(): void {
    grecaptcha.render('id_recaptcha', { sitekey: environment.recaptchaSiteKey, callback: window.respostaCallback });
  }

  respostaCallback(): void {
    const respostaRecaptcha = grecaptcha.getResponse();
    this.onResponder.emit(respostaRecaptcha);
  }

  resetaReCaptcha(): void {
    grecaptcha.reset();
  }

  adicionaScript(): void {
    const script = this.renderer.createElement('script');
    script.src = environment.recaptchaApi + `?onload=${window.carregaReCaptcha.name}&render=explicit`;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
  }

  removeScript(): void {
    const script = document.querySelector(`script[src^="${environment.recaptchaApi}"]`);
    if (script) {
      this.renderer.removeChild(document.body, script);
    }
  }
}
